import { useCallback, useEffect, useState } from 'react';
/**
 * Check if the mouse cursor is currently hovering on a given element.
 * Attach the `onRef` ref function to the element you want to check hovering state for.
 *
 * Does not trigger for touch devices
 */
export const useIsHovering = () => {
    const [isHovering, setIsHovering] = useState(false);
    const [hoverItem, setHoverItem] = useState(null);
    // Check if the device media query for hover is active or not
    const isTouchScreenDevice = matchMedia('(hover: none)').matches;
    const onRef = (node) => {
        if (node) {
            setHoverItem(node);
        }
    };
    const onMouseEnter = useCallback(() => {
        if (!isTouchScreenDevice) {
            setIsHovering(true);
        }
    }, [isTouchScreenDevice]);
    const onMouseLeave = useCallback(() => {
        if (!isTouchScreenDevice) {
            setIsHovering(false);
        }
    }, [isTouchScreenDevice]);
    // Attach and remove event listeners when the element changes
    // The idea is to attach the listeners once when the element is available (mounted)
    useEffect(() => {
        hoverItem?.addEventListener('mouseenter', onMouseEnter);
        hoverItem?.addEventListener('mouseleave', onMouseLeave);
        return () => {
            hoverItem?.removeEventListener('mouseenter', onMouseEnter);
            hoverItem?.removeEventListener('mouseleave', onMouseLeave);
        };
    }, [hoverItem, onMouseEnter, onMouseLeave]);
    return {
        /** If the cursor is hovering on the element. */
        isHovering,
        /** Ref for the element to check hovering state. Attach this to the element you want to check hovering state for. */
        onRef
    };
};
//# sourceMappingURL=useIsHovering.js.map